import { createRootRoute } from '@tanstack/react-router';
import { RequireAuth } from '@/auth/RequireAuth.tsx';
import { AppLayout } from '@/components/layout/AppLayout.tsx';
import { NotFoundPage } from '@/features/not-found/NotFoundPage.tsx';

/** Root route: every page sits behind sign-in and inside the app layout. */
export const rootRoute = createRootRoute({
  component: () => (
    <RequireAuth>
      <AppLayout />
    </RequireAuth>
  ),
  notFoundComponent: NotFoundPage,
});
